'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef, cloneElement } from 'react';
import { useAvatarContext, useAvatarStyles } from './avatar-context.mjs';
import { chakra } from '../system/factory.mjs';

const AvatarFallback = forwardRef(
  function AvatarFallback2(props, ref) {
    const { icon, iconLabel, name, showFallback, getInitials } = useAvatarContext();
    const styles = useAvatarStyles();
    if (!showFallback)
      return null;
    if (name != null) {
      return /* @__PURE__ */ jsx(
        chakra.div,
        {
          ref,
          role: "img",
          "aria-label": name,
          ...props,
          __css: styles.label,
          children: getInitials(name)
        }
      );
    }
    return cloneElement(icon, {
      ref,
      role: "img",
      "aria-label": iconLabel
    });
  }
);
AvatarFallback.displayName = "AvatarFallback";

export { AvatarFallback };
